/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      Company
      Rep
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      Company
      Rep
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      Company
      Rep
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUsers = /* GraphQL */ `
  mutation CreateUsers(
    $input: CreateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    createUsers(input: $input, condition: $condition) {
      id
      eMail
      KeyUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers(
    $input: UpdateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    updateUsers(input: $input, condition: $condition) {
      id
      eMail
      KeyUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers(
    $input: DeleteUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    deleteUsers(input: $input, condition: $condition) {
      id
      eMail
      KeyUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMaterial = /* GraphQL */ `
  mutation CreateMaterial(
    $input: CreateMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    createMaterial(input: $input, condition: $condition) {
      id
      ToolNumber
      Specification
      Shape
      Dim_Nomclature
      Dim_Value
      Shelf_Level_Target
      Restock_Level
      Shelf_Level_Actual
      StorageLocation
      CustomerPartNumber
      Live
      On_Order
      LW_Stock
      materialCustomerId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMaterial = /* GraphQL */ `
  mutation UpdateMaterial(
    $input: UpdateMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    updateMaterial(input: $input, condition: $condition) {
      id
      ToolNumber
      Specification
      Shape
      Dim_Nomclature
      Dim_Value
      Shelf_Level_Target
      Restock_Level
      Shelf_Level_Actual
      StorageLocation
      CustomerPartNumber
      Live
      On_Order
      LW_Stock
      materialCustomerId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMaterial = /* GraphQL */ `
  mutation DeleteMaterial(
    $input: DeleteMaterialInput!
    $condition: ModelMaterialConditionInput
  ) {
    deleteMaterial(input: $input, condition: $condition) {
      id
      ToolNumber
      Specification
      Shape
      Dim_Nomclature
      Dim_Value
      Shelf_Level_Target
      Restock_Level
      Shelf_Level_Actual
      StorageLocation
      CustomerPartNumber
      Live
      On_Order
      LW_Stock
      materialCustomerId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      OrderNumber
      Quantity
      ExpectedDeliveryDate
      materialID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      OrderNumber
      Quantity
      ExpectedDeliveryDate
      materialID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      OrderNumber
      Quantity
      ExpectedDeliveryDate
      materialID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBookedItems = /* GraphQL */ `
  mutation CreateBookedItems(
    $input: CreateBookedItemsInput!
    $condition: ModelBookedItemsConditionInput
  ) {
    createBookedItems(input: $input, condition: $condition) {
      id
      Amount
      LastBookedOut
      LastGoodsIn
      LastBookedOut_Amount
      LastGoodsIn_Amount
      GoodsIN
      EmailList
      ToolNumber
      CustomerName
      StorageLocation
      Rep
      Notes
      ToolNumberID
      CustomerNameID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBookedItems = /* GraphQL */ `
  mutation UpdateBookedItems(
    $input: UpdateBookedItemsInput!
    $condition: ModelBookedItemsConditionInput
  ) {
    updateBookedItems(input: $input, condition: $condition) {
      id
      Amount
      LastBookedOut
      LastGoodsIn
      LastBookedOut_Amount
      LastGoodsIn_Amount
      GoodsIN
      EmailList
      ToolNumber
      CustomerName
      StorageLocation
      Rep
      Notes
      ToolNumberID
      CustomerNameID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBookedItems = /* GraphQL */ `
  mutation DeleteBookedItems(
    $input: DeleteBookedItemsInput!
    $condition: ModelBookedItemsConditionInput
  ) {
    deleteBookedItems(input: $input, condition: $condition) {
      id
      Amount
      LastBookedOut
      LastGoodsIn
      LastBookedOut_Amount
      LastGoodsIn_Amount
      GoodsIN
      EmailList
      ToolNumber
      CustomerName
      StorageLocation
      Rep
      Notes
      ToolNumberID
      CustomerNameID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const bookMaterial = /* GraphQL */ `
  mutation BookMaterial($input: BookMaterialInput!) {
    bookMaterial(input: $input) {
      material {
        id
        ToolNumber
        Specification
        Shape
        Dim_Nomclature
        Dim_Value
        Shelf_Level_Target
        Restock_Level
        Shelf_Level_Actual
        StorageLocation
        CustomerPartNumber
        Live
        On_Order
        LW_Stock
        materialCustomerId
        createdAt
        updatedAt
        __typename
      }
      bookedItem {
        id
        Amount
        LastBookedOut
        LastGoodsIn
        LastBookedOut_Amount
        LastGoodsIn_Amount
        GoodsIN
        EmailList
        ToolNumber
        CustomerName
        StorageLocation
        Rep
        Notes
        ToolNumberID
        CustomerNameID
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
